// extracted by mini-css-extract-plugin
module.exports = {"blog-grid":"BlogGridSection_blog-grid__vLure"};